export const ADMIN_COGNITO_CONSOLE_GROUP_NAME = "s2z-console-users";
export const ADMIN_COGNITO_PROVIDER_NAME = "s2z-workspace";
